<template>
    <v-speed-dial id="mover-topo" fixed bottom right direction="bottom">
        <template #activator>
            <v-btn color="primary darken-1" dark fab @click="rolarTopo">
                <v-icon> mdi-chevron-up </v-icon>
            </v-btn>
        </template>
    </v-speed-dial>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    window.onscroll = function () {
      var elemento = document.getElementById("mover-topo")

      if (window.scrollY > 0) {
        elemento.classList.add("ativo")
      } else {
        elemento.classList.remove("ativo")
      }
    }
  },
  methods: {
    rolarTopo() {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
    },
  },
}
</script>
<style lang="scss">
#mover-topo {
  z-index: 998;
  display: none;

  &.ativo {
    display: block;
  }
}
</style>
